import React, {Component} from 'react';
import {Col, Form, FormGroup, Label} from 'reactstrap';

class FormBool extends Component {
	render() {
		let usefulValue = this.props.value === '1';
		let displayLabel = this.props.humanLabel;
		if (this.props.dbView) {
			displayLabel = `${this.props.parentID.split('-')[0]}.${this.props.label}`;
		}
		switch (this.props.value) {
		case '0':
		case '1':
			return (
				<Col xs={this.props.colsize}>
					<FormGroup>
						<Label
							className="simpleLabel"
							for={`${this.props.parentID}-${this.props.label}`}
						>
							{displayLabel}{' '}
						</Label>
						<label className="switch">
							<div className="switchText">
								<div className="switchLft">Yes</div>
								<div className="switchRt">No</div>
							</div>
							<input
								type="checkbox"
								checked={usefulValue}
								id={`${this.props.parentID}-${this.props.label}`}
								onChange={(e) => {
									this.props.triggerFormBoolChange(e, usefulValue);
								}}
							/>
							<span className="slider" />
						</label>
					</FormGroup>
				</Col>
			);
		default:
			return (
				<Col xs={this.props.colsize}>
					<Label>{this.props.humanLabel}</Label>
					<p>Neither "1" nor "0", cannot render as bool</p>
				</Col>
			);
		}
	}
}

export default FormBool;



// WEBPACK FOOTER //
// ./src/components/FormBool.js